import styled from 'styled-components';
import { MOBILE_MEDIA, DESKTOP_MEDIA } from '@/constants/breakpoints';

const Flex = styled.div`
  display: ${({ display }) => display || 'flex'};
  flex-wrap: ${({ wrap }) => wrap || 'no-wrap'};
  box-sizing: ${({ boxSizing }) => boxSizing || 'border-box'};
  gap: ${({ gap }) => gap || '0px'};
  padding: ${({ pd }) => pd || '0px'};
  margin-top: ${({ mt }) => mt || '0px'};
  margin-bottom: ${({ mb }) => mb || '0px'};
  margin-left: ${({ ml }) => ml || '0px'};
  margin-right: ${({ mr }) => mr || '0px'};
  flex-direction: ${({ direction }) => direction || 'row'};
  align-items: ${({ align }) => align || 'start'};
  justify-content: ${({ justify }) => justify || 'flex-start'};
  background: ${({ bg }) => bg || 'none'};
  height: ${({ h }) => h || 'fit-content'};
  width: ${({ w }) => w || '100%'};
  color: ${({ color }) => color || 'black'};
  box-shadow: ${({ shadow }) => shadow || 'none'};
  cursor: ${({ cursor }) => cursor || 'default'};
  border-radius: ${({ radius }) => radius || '0px'};
  min-height: ${({ minHeight }) => minHeight || 'auto'};
  overflow-x: ${({ overflowX }) => overflowX || 'visible'};
  overflow-y: ${({ overflowY }) => overflowY || 'visible'};
  position: ${({ position }) => position || 'static'};

  /* sm = layout mobile completo (teléfonos y tablets en vertical, ver
     constants/breakpoints.js), no solo hasta 575px. md/lg siguen acotando
     rangos más específicos y, al ir después, pueden afinar sobre sm. */
  @media ${MOBILE_MEDIA} {
    ${({ sm }) => sm}
  }

  @media (min-width: 576px) and (max-width: 767px) {
    ${({ md }) => md}
  }

  @media (min-width: 768px) and (max-width: 991px) {
    ${({ lg }) => lg}
  }

  /* xl = laptops/tablets horizontales de 992 a 1199px; una pantalla vertical
     de hasta 1100px ya es layout mobile, así que no entra aquí. */
  @media (min-width: 1101px) and (max-width: 1199px), (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
    ${({ xl }) => xl}
  }

  @media (min-width: 1200px) {
    ${({ xxl }) => xxl}
  }

  @media (min-width: 1400px) {
    ${({ bigger }) => bigger}
  }
`;

export default Flex;
